module.exports = __webpack_public_path__ + "static/media/search_icon.54498b6b.svg";